<template>
  <div>
    <page-header
      title="Settlement"
      breadcrumb="Billings & Collections > Settlements"
    />

    <section class="bg-white my-4 p-3">
      <div>
        
        <div class="detail-point flex py-4 justify-between">
          <span class="w-12">
            <Tabicon color="#09B78A" />
          </span>
          <p class="w-full flex justify-between">
            <span class="detail-element"
              >Total Partner Revenue: ₦
              {{
                settlementProperty.totalPartnerRevenue
                  ? settlementProperty.totalPartnerRevenue.toLocaleString()
                  : "N/A"
              }}</span
            >
            <span class="detail-element-2"
              >Partner Collections: ₦{{
                settlementProperty.totalCollection !== ""
                  ? settlementProperty.totalCollection.toLocaleString()
                  : "N/A"
              }}</span
            >
            <span class="detail-element-2"
              >Platform Collections: ₦{{
                settlementProperty
                  ? settlementProperty.totalPlatformCollection
                  : "N/A"
              }}</span
            >
          </p>
        </div>
        <div class="detail-point flex py-4 justify-between">
          <span class="w-12">
            <Tabicon color="#D72638" />
          </span>
          
          <p class="w-full flex py-4 justify-between">
            <span class="detail-element"
              >Total Partner Earnings: ₦
              {{
                settlementProperty
                  ? settlementProperty.totalPartnerEarning.toLocaleString()
                  : "N/A"
              }}
            </span>
            <span class="detail-element-2"
              >Settlement to Date: ₦{{
                settlementProperty
                  ? settlementProperty.totalPlatformSettlement
                  : "N/A"
              }}
            </span>
            <span class="detail-element-2"
              >Net Settlement Bal: ₦{{
                settlementProperty
                  ? settlementProperty.totalNetSettlement.toLocaleString()
                  : "N/A"
              }}
            </span>
          </p>
        </div>
      </div>

      <TableSettlementFilter @setQueryparams="sortItemProps" />
      <div v-loading="loading">
        <TableSettlement :tableContent="allSettlement" />
      </div>
      <PaginationControl
        :total="totalSettlement"
        :pageNumber="sortOptions.pageNumber"
        @pageNumber="setPageDisplaySettlement"
        @pageSize="setNumDisplaySettlement"
      />
    </section>
  </div>
</template>

<script>
import moment from "moment";
import TableSettlementFilter from "../modules/TableSettlementFilter.vue";
import TableSettlement from "../modules/TableSettlement.vue";
import PageHeader from "@/components/UI/NewPageHeader";
import PaginationControl from "@/components/UI/pagination";
import Tabicon from "@/assets/images/billing/Tabicon";

export default {
  data() {
    return {
      currentTab: "private",
      totalSettlement: null,
      loading: true,
      sortOptions: {
        pageSize: 10,
        pageNumber: 1,
        startDate: null,
        endDate: null,
        searchString: "",
      },
      allSettlement: [],
      settlementProperty: {},
    };
  },
  computed: {
    payload() {
      return {
        pageSize: this.sortOptions.pageSize,
        pageNumber: this.sortOptions.pageNumber,

        customerType: "3PL",
        type: this.currentTab,

        searchTerm: this.sortOptions.searchString,
        startDate:
          this.sortOptions.startDate != null
            ? moment(this.sortOptions.startDate).format("YYYY-MM-DD")
            : "",
        endDate:
          this.sortOptions.endDate != null
            ? moment(this.sortOptions.endDate).format("YYYY-MM-DD")
            : "",
      };
    },
  },
  watch: {
    sortOptions() {
      this.getAllSettlemet();
    },
    currentTab() {
      this.getAllSettlemet();
    },
  },
  components: {
    TableSettlementFilter,
    TableSettlement,
    PageHeader,
    PaginationControl,
    Tabicon,
  },
  mounted() {
    this.getAllSettlemet();
  },
  methods: {
    setNumDisplaySettlement(val) {
      this.sortOptions = { ...this.sortOptions, pageSize: val };
    },
    setPageDisplaySettlement(val) {
      this.sortOptions = { ...this.sortOptions, pageNumber: val };
    },
    sortItemProps(val) {
      this.sortOptions = { ...this.sortOptions, ...val };
    },
    async getAllSettlemet() {
      this.loading = true;
      try {
        let response = await this.$_getAllSettlement(this.payload);
        this.allSettlement = response.data.data.transactions;
        this.settlementProperty = response.data.data;
        this.totalSettlement = response.data.data.totalCount;
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;
  @apply bg-gray-300;
  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #fcc210;
    font-weight: bold;
  }
}
.unit-point {
  @apply flex shadow-xl px-4 py-4 rounded-lg items-center;
  width: 47%;
}
.detail-point {
  @apply flex shadow-xl my-3 px-4 py-4 rounded-lg items-center;
  // width: 31%;
  height: 80px;
  background: #f9fafc;
}
.detail-element {
  @apply w-full text-center  py-1;
  font-size: 16px;
  font-weight: 700;
}
.detail-element-2 {
  @apply w-full  py-1 text-center;
  font-size: 14px;
  font-weight: 600;
  border-left: 1px dashed;
}
</style>
